<div class="container section-gap">
  <div class="row">
    <div class="col-lg-6 col-sm-12 col-12">
      <kla-title [lineConfig]="lineConfig" [config]="config.title" [showFooter]="false"></kla-title>
    </div>
    <div class="col-lg-6 col-sm-12 col-xs-12">
      <div class="row chart" #panel>
        <kla-ring-chart
          *ngIf="chartConfig.data"
          id="{{chartConfig.id}}"
          [config]="chartConfig"
          [width]="chartConfig.width"
          class="center"
          [chartAltText]="config.chartAltText">
        </kla-ring-chart>
      </div>
      <div class="footer-paragraph" *ngIf="config.title.footer">
        <app-dynamic-content
          [contentId]="'ring-graph-footer'"
          [htmlContent]="config.title.footer">
        </app-dynamic-content>
      </div>
    </div>
    <div class="col-lg-6" *ngFor="let config of listOfNews">
      <kla-news [config]="config"></kla-news>
    </div>
  </div>
</div>
